import Vue from 'vue'

Vue.filter('tofloat', function(value, num) {
    if(value == undefined || value == null){
        return
    }
    return parseFloat(value).toFixed(num)
})

Vue.filter('intToChinese', function(value) {
    var unit = "京亿万仟佰拾兆万仟佰拾亿仟佰拾万仟佰拾元角分",
    str = "";
    value += "00";
    var p = value.indexOf('.');
    if (p >= 0)
        value = value.substring(0, p) + value.substr(p+1, 2);
    unit = unit.substr(unit.length - value.length); 
    for (var i=0; i < value.length; i++){
        str += '零壹贰叁肆伍陆柒捌玖'.charAt(value.charAt(i)) + unit.charAt(i);  
    }
    return str.replace(/零(仟|佰|拾|角)/g, "零").replace(/(零)+/g, "零").replace(/零(兆|万|亿|元)/g, "$1").replace(/(兆|亿)万/g, "$1").replace(/(京|兆)亿/g, "$1").replace(/(京)兆/g, "$1").replace(/(京|兆|亿|仟|佰|拾)(万?)(.)仟/g, "$1$2零$3仟").replace(/^元零?|零分/g, "").replace(/(元|角)$/g, "$1整");
})

Vue.filter('formatDate', function(input) {
    if(input){
        var d = new Date(input);
        var year = d.getFullYear();
        var month = d.getMonth() + 1;
        month = month < 10 ? '0' + month : month;
        var day = d.getDate() <10 ? '0' + d.getDate() : '' + d.getDate();
        var hour = d.getHours();
        var minutes = d.getMinutes();
        var seconds = d.getSeconds();
        return year+ '-' + month + '-' + day
    }else{
        return ''
    }
})
Vue.filter('toWan', function(value) {
	var r= /^[+-]?[1-9]?[0-9]*\.[0-9]*$/;
	 if (value >= 10000 && value < 10000000) {
            value = value / 10000;
            if(r.test(value)){
		        return (value%10000) ? (value.toFixed(2) + '万') : (value+'万');
		    }
     } else if (value >= 10000000) {
            value = value / 100000000;
            if(r.test(value)){
		        return (value%10000000) ? (value.toFixed(2) + '亿') : (value+'亿');
		    }
     }
     return null;
});   

Vue.filter('hideMobile', function(value) {
    if(value){
        return value.substring(0, 3) + '****' + value.substring(7, 11) 
    }else{
        return ''
    }
})


// WEBPACK FOOTER //
// ./src/js/filter.js